// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuButtonDelete_wrapper__il-3M","loader":"MenuButtonDelete_loader__5as8q","label":"MenuButtonDelete_label__3e8P1"};